import React, { useState } from 'react';
import Header from '../components/ownerManagement/title';
import TagManagement from '../components/ownerManagement/tagManagement';
import DataImport from '../components/ownerManagement/databaseImport/databaseImport';
import PageLayout from '../components/layouts/pageLayout';


const ManageDatabase = () => {
  const [activeView, setActiveView] = useState('tagManagement');

  const renderView = () => {
    switch (activeView) {
      case 'tagManagement':
        return <TagManagement />;
      case 'databaseImport':
        return <DataImport />;
      case 'manageUsers':
        return <p>Under development</p>;
      default:
        return <TagManagement />;
    }
  };

  return (
    <PageLayout>
      <Header setActiveView={setActiveView} />
      {renderView()}
    </PageLayout>
  );
};

export default ManageDatabase;